import React, { ReactElement, useCallback } from 'react';
import { WrappedFieldProps } from 'redux-form';
import i18n from '../../../i18n';
import { FormControlLabel, Grid, makeStyles, RadioGroup, useMediaQuery } from '@material-ui/core';

import { RadioButton } from 'components/RadioButton/RadioButton';

import { PaidDeliveryType } from 'types';
import { useTheme } from '@material-ui/core/styles';

interface PaidDeliveryTypeSelectProps {
    isDisabled: boolean;
    firstMethodControls: ReactElement;
    secondMethodControls: ReactElement;
}

const useClasses = makeStyles({
    label: {
        whiteSpace: 'nowrap',
    },
});

export const PaidDeliveryTypeSelect = (props: PaidDeliveryTypeSelectProps & WrappedFieldProps) => {
    const {
        input: { value, onChange, name },
        firstMethodControls,
        secondMethodControls,
    } = props;

    const theme = useTheme();

    const isLargeScreen = useMediaQuery(theme.breakpoints.up(480));

    const { t } = i18n.useTranslation();

    const handlePaidDeliveryTypeChange = useCallback(
        (_, value) => {
            onChange(value);
        },
        [onChange],
    );

    const classes = useClasses();
    return (
        <RadioGroup name={name} value={value} onChange={handlePaidDeliveryTypeChange}>
            <Grid container spacing={1}>
                <Grid item>
                    <FormControlLabel
                        className={classes.label}
                        disabled={props.isDisabled}
                        value={PaidDeliveryType.STATIC}
                        control={<RadioButton />}
                        label={t('onboarding:settings.deliveryCard.pricingModelStatic')}
                    />
                </Grid>
                <Grid item>{firstMethodControls}</Grid>
                <Grid item>
                    <FormControlLabel
                        className={classes.label}
                        disabled={props.isDisabled}
                        value={PaidDeliveryType.PER_KM}
                        control={<RadioButton />}
                        label={t('onboarding:settings.deliveryCard.pricingModelPerKm')}
                    />
                </Grid>{' '}
                <Grid item>{secondMethodControls}</Grid>
            </Grid>
        </RadioGroup>
    );
};
